export const API_URL_SEND_EMAIL_ESIM = "/shop/api/esim/sendemail";
export const API_URL_SEND_CODE_ESIM = "/shop/api/checkout/sendcodeesim";
export const API_URL_VERIFY_CODE_ESIM = "/shop/api/checkout/verifycodeesim";
